module.exports = __webpack_public_path__ + "static/shadow-d9a385afb85056675824fdf7e58796aa.png";